import React from 'react'
import { Typography } from 'antd'
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons'
import styles from '../../Style/LayerOverview.module.scss'

interface ShapeFileLayersProps {
  shapeFiles: any[]
  dataset: string
  updateShowShape: (show: boolean, datasetId: string, level1: string, level2: string, color: string) => void
  showDisabledMessage?: boolean
}

const ShapeFileLayers: React.FC<ShapeFileLayersProps> = ({
   shapeFiles,
   dataset,
   updateShowShape,
   showDisabledMessage = false
 }) => {
  const filteredShapeFiles = shapeFiles.filter(item => item.Level2 === '2D Wave Spectra')

  if (filteredShapeFiles.length === 0 && !showDisabledMessage) {
    return null
  }

  return (
    <>
      {filteredShapeFiles.map((item) => (
        <div key={item.Level2} className={`${styles.menuRow}`}>
          <div className={styles.iconLabel}>
            <div style={{ width: 20, height: 20, paddingLeft: 16, borderStyle: 'solid', borderColor: item.LegendColor[0], borderWidth: '3px' }} />
            <Typography style={{ marginLeft: 5 }}>{item.Level2}</Typography>
          </div>
          <div className={`${styles.groupItem}`}>
            <div
              onClick={() => updateShowShape(!item.IsDisplay, dataset, item.Level1, item.Level2, item.LegendColor[0])}
              style={{ cursor: 'pointer', fontSize: '20px' }}
            >
              {item.IsDisplay ? <EyeOutlined /> : <EyeInvisibleOutlined />}
            </div>
          </div>
        </div>
      ))}

      {showDisabledMessage && filteredShapeFiles.length === 0 && (
        <div className={`${styles.menuRow}`}>
          <div className={styles.iconLabel}>
            <div className={styles.boxDisabled} />
            <Typography style={{ marginLeft: 5, color: 'grey' }}>2D Wave Spectra</Typography>
          </div>
          <div className={styles.groupItem}>
            <div style={{ cursor: 'pointer', fontSize: '20px' }}>
              <EyeInvisibleOutlined disabled style={{ cursor: 'not-allowed' }} />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default ShapeFileLayers
